import reducer from './reducer'
import type { State } from './reducer'

import * as enrolmentsActions from './actions'
import enrolmentsSagas from './sagas'

export {
  enrolmentsActions,
  enrolmentsSagas
}

export type EnrolmentsState = State;

export default reducer
